import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomerService } from '@app/services/customer.service';
import { NotificationService } from '@app/services/notification.service';
import { GlobalErrorHandlerService } from '@app/services/global-error-handler.service';
import { CustomerFilter } from '@app/models/customer-filter';
import { CustomerSummary } from '@app/models/customer-summary';

@Component({
    selector: 'app-advanced-search-customer-popup',
    templateUrl: './advanced-search-customer-popup.component.html',
    styleUrls: ['./advanced-search-customer-popup.component.css'],
    standalone: false
})
export class AdvancedSearchCustomerPopupComponent implements OnInit {

  customerFilter: CustomerFilter;

  @Input() displaySearchDialog: boolean;
  @Output() onSubmit = new EventEmitter<CustomerFilter>();
  @Output() onCancel = new EventEmitter();

  
  searchingCustomer: CustomerFilter;
  
  customerPageIndex: number = 0;
  customerPageSize: number = 5;
  
  customers: Array<CustomerSummary>;
  totalCustomers: number = 0;
  displaySearchDialogResult = false;

  constructor(
    private notificationService: NotificationService,
    private customerService: CustomerService,
    private errorService: GlobalErrorHandlerService,) { }

  ngOnInit() {
    this.searchingCustomer = new CustomerFilter();
  }
  
  hideAdvancedSearch() {
    this.onCancel.emit();
  }

  showAdvancedSearchResult() {
    this.displaySearchDialogResult = true;
  }

  advancedSearch(searchingCustomer: CustomerFilter) {
    this.searchingCustomer = searchingCustomer;
    this.showAdvancedSearchResult();
  }

  getCustomers() {
    const pageOption = {
      size: this.customerPageSize,
      page: this.customerPageIndex,
      ...this.searchingCustomer,
      sortBy: 'firstName',
      isDesc: false
    }

    const pageParams = {...pageOption };
    this.customerService.getSummaryList(pageParams).subscribe({
      next: (data) => {
        if(data && data.content)
        {
          this.customers = data.content;
          this.totalCustomers = data.totalElements;
        }
      },
      error: (err) => {
        let errorMessage = this.errorService.handleError(err);
        this.notificationService.showError("<i class='fa fa-times-circle'></i> <p>"+ `${errorMessage}`+"</p>", "")
      }
    });
  }

  onSearchLoadData(event) {
    if (event) {
      this.customerPageIndex = Math.floor(event.first / event.rows);
      this.customerPageSize = event.rows;
      this.getCustomers();
    }
  }

  onSubmitSelectedCustomer(customer) {
    if (customer) {
      this.onSubmit.emit(customer);
    }
  }

}
